import React from 'react'
import {connect} from "react-redux";
import DayPicker, {DateUtils} from 'react-day-picker';
import DataAction from "../../../stores/api/DataAction";
import Loader from 'react-loader-spinner'

const mapStateToProps = (state, ownProps) => ({
    ...state
});

function Navbar({onPreviousClick, onNextClick})
{
    const handleNextClick = () => {
        onNextClick()
    };

    const handlePrevClick = () => {
        onPreviousClick()
    };

    return (
        <div className={'DayPicker-NavBar'}>
            <button className={'DayPicker-arrow-left'} onClick={() => handlePrevClick()}>
                <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="211546-Website-Zoon-Badkamer-&amp;-Tegels-[afspraak-maken]-[D]-[1]" transform="translate(-764.000000, -544.000000)" fill="#27656B">
                            <g id="Group-11" transform="translate(764.850000, 544.960000)">
                                <path d="M8.89832102,0 C9.1607061,0.0857607112 9.34606525,0.274674371 9.5348153,0.464027228 C11.2314611,2.16615336 12.9293345,3.86710829 14.6300728,5.56513524 C14.889447,5.82405704 15.0135946,6.11834892 14.8945918,6.47392354 C14.8501886,6.60656131 14.7622884,6.73688597 14.6627832,6.83693525 C12.8926193,8.61691653 11.1185384,10.3929743 9.34290821,12.1675095 C8.96271878,12.547445 8.48884128,12.5419111 8.10409168,12.1643473 C7.99298142,12.0553091 7.88952991,11.9376333 7.7722225,11.8358858 C7.29939734,11.4257043 7.31804726,10.8803961 7.76435913,10.4475812 C8.75260025,9.48919285 9.7180113,8.50723417 10.6934781,7.535582 C10.7311872,7.49801594 10.7763212,7.46788697 10.8179765,7.43430297 C10.8128902,7.41989728 10.8078039,7.40552086 10.8027175,7.39111517 L10.6417377,7.39111517 C7.44742742,7.39111517 4.25308788,7.38391233 1.05883604,7.39823018 C0.530090351,7.40060185 0.16472147,7.23979685 0,6.71858606 L0,5.69619189 C0.157150421,5.20470015 0.504278628,5.04544699 1.0031786,5.04720378 C4.2014352,5.05835941 7.39975028,5.05291336 10.5980361,5.05291336 C10.6538105,5.05291336 10.7095556,5.05291336 10.7953219,5.05291336 C10.7360689,4.99028374 10.7012245,4.95172216 10.664597,4.91497593 C9.68965641,3.93650156 8.71436499,2.95837854 7.73974591,1.97958208 C7.68496543,1.92456523 7.63062342,1.8680551 7.58385246,1.80633315 C7.36262583,1.51423726 7.34669447,1.08757114 7.58747721,0.819543294 C7.8693307,0.505780309 8.12864643,0.155768858 8.54821116,0 L8.89832102,0 Z" id="Fill-1"></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </button>
            <button className={'DayPicker-arrow-right'} onClick={() => handleNextClick()}>
                <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="211546-Website-Zoon-Badkamer-&amp;-Tegels-[afspraak-maken]-[D]-[1]" transform="translate(-764.000000, -544.000000)" fill="#27656B">
                            <g id="Group-11" transform="translate(764.850000, 544.960000)">
                                <path d="M8.89832102,0 C9.1607061,0.0857607112 9.34606525,0.274674371 9.5348153,0.464027228 C11.2314611,2.16615336 12.9293345,3.86710829 14.6300728,5.56513524 C14.889447,5.82405704 15.0135946,6.11834892 14.8945918,6.47392354 C14.8501886,6.60656131 14.7622884,6.73688597 14.6627832,6.83693525 C12.8926193,8.61691653 11.1185384,10.3929743 9.34290821,12.1675095 C8.96271878,12.547445 8.48884128,12.5419111 8.10409168,12.1643473 C7.99298142,12.0553091 7.88952991,11.9376333 7.7722225,11.8358858 C7.29939734,11.4257043 7.31804726,10.8803961 7.76435913,10.4475812 C8.75260025,9.48919285 9.7180113,8.50723417 10.6934781,7.535582 C10.7311872,7.49801594 10.7763212,7.46788697 10.8179765,7.43430297 C10.8128902,7.41989728 10.8078039,7.40552086 10.8027175,7.39111517 L10.6417377,7.39111517 C7.44742742,7.39111517 4.25308788,7.38391233 1.05883604,7.39823018 C0.530090351,7.40060185 0.16472147,7.23979685 0,6.71858606 L0,5.69619189 C0.157150421,5.20470015 0.504278628,5.04544699 1.0031786,5.04720378 C4.2014352,5.05835941 7.39975028,5.05291336 10.5980361,5.05291336 C10.6538105,5.05291336 10.7095556,5.05291336 10.7953219,5.05291336 C10.7360689,4.99028374 10.7012245,4.95172216 10.664597,4.91497593 C9.68965641,3.93650156 8.71436499,2.95837854 7.73974591,1.97958208 C7.68496543,1.92456523 7.63062342,1.8680551 7.58385246,1.80633315 C7.36262583,1.51423726 7.34669447,1.08757114 7.58747721,0.819543294 C7.8693307,0.505780309 8.12864643,0.155768858 8.54821116,0 L8.89832102,0 Z" id="Fill-1"></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </button>
        </div>
    );
}

const MONTHS = [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
];

const WEEKDAYS_LONG = [
    'zondag',
    'maandag',
    'dinsdag',
    'woensdag',
    'donderdag',
    'vrijdag',
    'zaterdag',
];

let WEEKNUMS = [];
WEEKNUMS['maandag'] = 1
WEEKNUMS['dinsdag'] = 2
WEEKNUMS['woensdag'] = 3
WEEKNUMS['donderdag'] = 4
WEEKNUMS['vrijdag'] = 5
WEEKNUMS['zaterdag'] = 6
WEEKNUMS['zondag'] = 0


const WEEKDAYS_SHORT = ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'];

class Step1 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDay: null,
            selectedCalendarDay: null
        };
    }

    formatDate(date = new Date) {
        return WEEKDAYS_LONG[date.getDay()];
    }

    handleDayClick = (day, {selected}) => {
        this.setState({
            selectedCalendarDay: selected ? undefined : day,
        });

        let data = {}
        if (this.state.selectedDay === day.getDate()) {
            data = {selectedDayName: null, selectedDayNum: null}
            this.setState({selectedDay: undefined})
        } else {
            data = {selectedDayName: this.formatDate(day), selectedDayNum: day.getDate()}
            this.setState({selectedDay: day.getDate()})
        }
        this.props.dispatch(DataAction.setDayData(data))
    }

    handleMonthChange = (data) => {
        const date = {selectedMonth: MONTHS[data.getMonth()], selectedYear: data.getFullYear()}
        this.props.dispatch(DataAction.setMonthData(date))
    }

    handleTimeClick = (time) => {
        const data = {selectedTime: time}
        this.props.dispatch(DataAction.setTimeData(data))
    }

    getDisabledDays = () => {
        const days = this.props.data.dateTime.tijd_selectie

        const disabledDays = []
        if (days) {

            Object.keys(days).map((day) => {

                if (!days[day] || days[day][0].tijd === '') {
                    disabledDays.push(WEEKNUMS[day])
                }
            })
        }

        return disabledDays
    }

    nextStep = () => {
        this.props.dispatch(DataAction.nextStep())
    }

    render() {

        const disabledDays = this.getDisabledDays()
        let disableBtn = true
        let dayTimes = {}

        if (this.props.data.dateTime.tijd_selectie) {
            const selectedDay = this.props.data.selectedDayName
            dayTimes = this.props.data.dateTime.tijd_selectie[selectedDay]
        }

        if (this.props.data.selectedDayName !== null && this.props.data.selectedMonth !== null && this.props.data.selectedTime !== null) {
            disableBtn = false
        }

        return (

            <div>
                <header className="c-appointment__header">
                    {this.props.data.dateTime.titel &&
                    <h1>{this.props.data.dateTime.titel}</h1>
                    }
                    {this.props.data.dateTime.tekst &&
                    <p>{this.props.data.dateTime.tekst}</p>
                    }
                </header>

                {this.props.data.dateTime ? (

                    <div className="c-appointment__content-1">

                        <div className="c-appointment__datepicker">
                            <DayPicker
                                onMonthChange={this.handleMonthChange}
                                disabledDays={[{before: new Date()}, {daysOfWeek: disabledDays}]}
                                navbarElement={<Navbar />}
                                selectedDays={this.state.selectedCalendarDay}
                                onDayClick={this.handleDayClick}
                                locale="nl"
                                months={MONTHS}
                                firstDayOfWeek={0}
                                weekdaysShort={WEEKDAYS_SHORT}
                            />
                        </div>

                        <div className="c-appointment__time">
                            {this.props.data.selectedDayName && this.props.data.selectedMonth && this.props.data.selectedDayNum ? (
                                <div>
                                    <span>{this.props.data.selectedDayName + ' ' + this.props.data.selectedDayNum + ' ' + this.props.data.selectedMonth}</span>
                                    {dayTimes &&
                                    <div>
                                        {Object.values(dayTimes).map((day) => {
                                            let timeClass = 'c-appointment__time__single'
                                            if (day.tijd === this.props.data.selectedTime) {
                                                timeClass += ' isActive'
                                            }
                                            return (
                                                <button className={timeClass}
                                                        onClick={() => this.handleTimeClick(day.tijd)}>
                                                    <span>{day.tijd}</span>
                                                </button>
                                            )
                                        })}
                                    </div>
                                    }
                                </div>
                            ) : (
                                <span>kies een beschikbare dag</span>
                            )}
                        </div>

                    </div>

                ) : (

                    <Loader
                        type="ThreeDots"
                        color="#fff"
                        height={40}
                        width={60}
                        timeout={2000}
                    />

                )}

                <footer className="c-appointment__footer">
                    <button className="btn btn--rounded btn--beige-dark" disabled={disableBtn}
                            onClick={() => this.nextStep()}><span>Stap 2 - Uw wensen</span></button>
                </footer>
            </div>

        )

    }

}

export default connect(mapStateToProps)(Step1);
